import React, {
  useState,
  useEffect,
  Suspense,
  useContext,
  useCallback,
} from "react";
import { getTrans as T } from "../../../Shared/Language";
import {
  getEmployeeList,
  getEmployeeListDetailsByGUID,
} from "../EmployeeList/Service/employeeService";
import { TostMsg } from "../../../App";
import { Link, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { postEmployeeFollow } from "../Dashboard/Services/DashboardServices";
import moment from "moment";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
const ComponentLoader = React.lazy(() =>
  import("../../../Shared/Sidebar/ComponentLoader")
);

const defaultImage = "/images/placeholder_profile.png";

function UserFollowersList() {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [followersListData, setFollowersListData] = useState([]);
  const [Isloading, setIsloading] = useState(false);
  const toster = useContext(TostMsg);
  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage; // Set the fallback image on error
  }, []);
  const { UserId } = useParams();
  const [employee, setEmployee] = useState([]);
  const [employeeId, setEmployeeId] = useState(0);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [noData, setNoData] = useState([]);

  useEffect(() => {
    GetMasterSystemAlertList("Follower_Unavialable", 2);
    if (UserId) {
      fetchEmployeeIdData();
    }
  }, [UserId]);

  useEffect(() => {
    if (employeeId) {
      fetchEmployeeFolowersData();
    }
  }, [employeeId]);

  async function GetMasterSystemAlertList(message, type) {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      }else if (msg?.Name == message && type == 2) {
        setNoData(msg?.Desc);
      }
    });
  }

  async function fetchEmployeeIdData() {
    setIsloading(true);
    var params = {
      GUID: UserId,
    };
    try {
      setIsloading(false);
      let employeesList = await getEmployeeListDetailsByGUID(params);
      setEmployee([employeesList.Data]);
      setEmployeeId(employeesList.Data?.EmpId);
    } catch (error) {
      setIsloading(false);
    }
  }

  //Get Folowers list data of employee.
  async function fetchEmployeeFolowersData() {
    setIsloading(true);
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 1,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 1000000,
      EmployeeId: employeeId,
             IsSuggestedOnly: 0,
    };
    try {
      let employeesFolowersList = await getEmployeeList(params);
      let FollowersDataList = employeesFolowersList?.Data.filter(
        (Followers) => Followers.Id != Number(employeeId)
      );
      setFollowersListData(FollowersDataList);
      setIsloading(false);
    } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
      setIsloading(false);
    }
  }

  async function PostEmployeeFollow(Id) {
    let params = {
      FollowerId: userDetails?.EmpId,
      EmpId: Id,
    };
    try {
      const data = await postEmployeeFollow(params);
      fetchEmployeeFolowersData();
    } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  return (
    <div>
      <div>
        <div className="profile-module-follow">
          {Isloading ? (
            <Skeleton height={60} width="100%" />
          ) : (
            <div className="top-section-profile">
              <div className="row">
                <div className="media-flex-center mb-0">
                  <div className="d-flex align-items-center">
                  <div className="h-avatar is-large">
                    <div className="image">
                      {!employee[0]?.ProfileImage && (
                        <LazyImage
                          className="avatar"
                          src="/images/placeholder_profile.png"
                          data-demo-src="/images/placeholder_profile.png"
                          alt=""
                        />
                      )}
                      {employee[0]?.ProfileImage && (
                        <LazyImage
                          className="avatar"
                          src={employee[0]?.ProfileImage}
                          data-demo-src="/images/placeholder_profile.png"
                          alt=""
                        />
                      )}
                    </div>
                  </div>
                  <div className="flex-meta">
                    <span>{employee[0]?.FullName}</span>
                    <span>{employee[0]?.CurrentDesignation}</span>
                    <div className="employee-div d-flex">
                      {employee[0]?.EmploymentId && (
                        <span>Employee ID - {employee[0]?.EmploymentId}</span>
                      )}{" "}
                      {employee[0]?.Contacts?.map(
                        (contact) =>
                          contact.ContactTypeId == 104 &&
                          contact.Contact && (
                            <>
                              <span className="spancl"></span>
                              {employee[0]?.Code}
                              {contact.Contact}
                            </>
                          )
                      )}
                      {employee[0]?.UserName && (
                        <>
                          <span className="spancl"></span>{" "}
                          <span>{employee[0]?.UserName}</span>
                        </>
                      )}
                    </div>
                  </div>
                  </div>
                  <div className="btn-follow-un">
                    <Link to={`/Profile/${UserId ? UserId : userDetails.GUID}`}>
                      <button className="back-newticket w-auto float-right">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          className="bi bi-arrow-left-short"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fillRule="evenodd"
                            d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                          />
                        </svg>
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          )}

          {Isloading ? (
            <Skeleton height={60} width="100%" />
          ) : (
            <div className="detailed-section-profile">
              <div className="row g-3">
                <div className="following-list">
                  <h2 className="font-w600">
                    {T("Followers")} ({followersListData?.length})
                  </h2>
                  <ul className="list-group">
                    {followersListData.map((following, index) => (
                      <>
                        {employeeId !== following?.EmpId && (
                          <li className="list-group-item d-flex align-items-center justify-content-between">
                            <Link
                              to={`/Profile/${following.GUID}`}
                              className="d-flex align-items-center text-decoration-none"
                            >
                              <img
                                src={following?.ProfileImage || defaultImage}
                                onError={handleImageError}
                                className="rounded-circle me-2"
                                width="40"
                                height="40"
                                alt=""
                              />
                              <div className="follower-info">
                                <span className="w-space-no text-truncate">
                                  {following?.FullName}
                                </span>
                                <p>{following?.CurrentDesignation}</p>
                              </div>
                            </Link>
                            <div className="follower-action">
                              <p>
                                Following since:{" "}
                                <b>
                                  {" "}
                                  {moment(following?.FollowerSince).format(
                                    "MMM DD YYYY"
                                  )}
                                </b>
                              </p>
                              {userDetails?.EmpId !== following?.EmpId &&
                                employeeId !== following?.EmpId && (
                                  <>
                                    {following?.IsFollowed == 0 && (
                                      <button
                                        className="followbtn"
                                        onClick={() =>
                                          PostEmployeeFollow(following.Id)
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          fill="currentColor"
                                          className="bi bi-plus me-1"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                                        </svg>
                                        Follow
                                      </button>
                                    )}
                                    {following.IsFollowed == 1 && (
                                      <button
                                        className="followingbtn"
                                        onClick={() =>
                                          PostEmployeeFollow(following.Id)
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          fill="currentColor"
                                          className="bi bi-dash  me-1"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8" />
                                        </svg>
                                        Unfollow
                                      </button>
                                    )}
                                  </>
                                )}
                            </div>
                          </li>
                        )}
                      </>
                    ))}
                  </ul>
                  {Isloading && followersListData.length === 0 && (
                    <div className="notfound">
                      <img
                        src="/images/no-data-found/following.png"
                        alt="No data found"
                      />
                      <p>{noData}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {Isloading ? (
        <Suspense >
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}
export default UserFollowersList;
